import React, { useState, useEffect, useRef } from "react";
import { Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AppConfiguration } from "read-appsettings-json";
import "../../pages/Account/jobspace-account.css"; // shared JobSpace design system

/* ── inline icons (match the JobSpace account header) ── */
const Briefcase = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 8.5A2.5 2.5 0 0 1 5.5 6h13A2.5 2.5 0 0 1 21 8.5v9A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-9Z" stroke="#fff" strokeWidth="1.8" /><path d="M8.5 6V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1" stroke="#fff" strokeWidth="1.8" /></svg>
);
const Bell = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9Z" stroke="#3c4d44" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><path d="M13.7 21a2 2 0 0 1-3.4 0" stroke="#3c4d44" strokeWidth="1.8" strokeLinecap="round" /></svg>
);
const Chevron = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="m6 9 6 6 6-6" stroke="#7c8b82" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
);
const Ic = ({ children }) => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none">{children}</svg>);

const menuItemStyle = { display: "flex", width: "100%", alignItems: "center", gap: 12, padding: 11, border: "none", background: "transparent", borderRadius: 11, fontFamily: "inherit", fontSize: 14, fontWeight: 600, color: "#2c3d34", cursor: "pointer", textDecoration: "none", boxSizing: "border-box", textAlign: "left" };

const NavBar = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const [navClass, setnavClass] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [getBsicInfo, setBsicInfo] = useState("");

  // ── identity/role derived from the session (single source of truth) ──
  let uc = null;
  try { uc = JSON.parse(sessionStorage.getItem("userCollection")); } catch (e) { uc = null; }
  const loggedIn = Array.isArray(uc) && uc.length > 0;
  const sUser = loggedIn ? uc[0] : null;
  const isEmployer = loggedIn && (sUser.isEmployer === "1" || sUser.isEmployer === 1);
  const displayName = loggedIn
    ? (sUser.name && sUser.name.trim() !== "" ? sUser.name : `${sUser.firstName || ""} ${sUser.lastName || ""}`.trim() || sUser.userid || "Account")
    : "";
  const displayEmail = loggedIn ? (sUser.email || sUser.userid || "") : "";
  const initials = (displayName || "U").trim().charAt(0).toUpperCase();

  useEffect(() => {
    const onScroll = () => setnavClass(window.pageYOffset > 0 ? "nav-sticky" : "");
    window.addEventListener("scroll", onScroll, true);
    return () => window.removeEventListener("scroll", onScroll, true);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  useEffect(() => {
    if (loggedIn && !isEmployer) GetCandidateRegisteredCheckList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // candidate profile checklist → drives onclickCandidate target (read only)
  const GetCandidateRegisteredCheckList = async () => {
    try {
      const Params = { _collection: "CandidateRegisteredCheckList", filter_data: { isDeleted: "0", userId: sUser.userid } };
      const res = await axios.post(AppConfiguration.Setting().jobspaceapi + "action/get", Params);
      const arr = [];
      (res.data.CandidateRegisteredCheckList || []).forEach((itm) => {
        try { arr.push(JSON.parse(("{" + itm.substring(46)).replace(/'/g, '"'))); } catch (e) { /* skip */ }
      });
      if (arr.length > 0) setBsicInfo(arr[0].basicInfoCandidate);
    } catch (e) { /* ignore */ }
  };

  const onclickCandidate = () => {
    setMenuOpen(false);
    navigate(getBsicInfo === "1" ? "/ApplicationFormView" : "/ApplicationFormCreate");
  };

  // employer "My Profile" → routes to the (read-only) company profile view (mirrors legacy checklistCompany)
  const checklistCompany = async () => {
    setMenuOpen(false);
    let user = null;
    try { user = JSON.parse(sessionStorage.getItem("userdata")); } catch (e) { user = null; }
    if (!user || !user[0]) { navigate("/CompanyRegisterView"); return; }
    try {
      const Params = { _collection: "CompanyRegisteredCheckList", filter_data: { isDeleted: "0", userId: user[0].userid } };
      const res = await axios.post(AppConfiguration.Setting().jobspaceapi + "action/get", Params);
      const arr = [];
      (res.data.CompanyRegisteredCheckList || []).forEach((itm) => {
        try { arr.push(JSON.parse(("{" + itm.substring(46)).replace(/'/g, '"'))); } catch (e) { /* skip */ }
      });
      if (arr.length > 0 && arr[0].basicInfoCompany === "0") navigate("/CompanyRegister");
      else navigate("/CompanyRegisterView");
    } catch (e) { navigate("/CompanyRegisterView"); }
  };

  const logout = () => { try { sessionStorage.clear(); localStorage.clear(); } catch (e) { /* ignore */ } window.location.href = "/"; };

  const navLink = (label, to) => (
    <Link to={to} style={{ padding: "8px 13px", borderRadius: 9, fontSize: 14.5, fontWeight: 500, color: "#5f7068", textDecoration: "none" }}>{label}</Link>
  );

  const employerItems = [
    { label: "List of Candidates", to: "/ListOfCandidate" },
    { label: "Prescreened", to: "/PreScreenCandidates" },
    { label: "Shortlisted", to: "/ShortListed" },
    { label: "Keep Warm", to: "/KeepWarmCandidates" },
    { label: "Not Qualified", to: "/NotQualifiedCandidates" },
    { label: "Hired Candidates", to: "/HiredCandidList" },
    { label: "Job Posting", to: "/EmployerJobPostingList" },
    { label: "My Documents", to: "/CompanyDocumentsView" },
  ];

  const tableIcon = (<Ic><rect x="4" y="4" width="16" height="16" rx="3" stroke="#3c4d44" strokeWidth="1.8" /><path d="M8 9h8M8 13h8M8 17h5" stroke="#3c4d44" strokeWidth="1.8" strokeLinecap="round" /></Ic>);
  const userIcon = (<Ic><circle cx="12" cy="8" r="3.4" stroke="#3c4d44" strokeWidth="1.8" /><path d="M5 20c0-3.3 3.1-5 7-5s7 1.7 7 5" stroke="#3c4d44" strokeWidth="1.8" strokeLinecap="round" /></Ic>);
  const fileIcon = (<Ic><path d="M14 3v5h5" stroke="#3c4d44" strokeWidth="1.8" strokeLinejoin="round" /><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" stroke="#3c4d44" strokeWidth="1.8" strokeLinejoin="round" /></Ic>);
  const gearIcon = (<Ic><circle cx="12" cy="12" r="3" stroke="#3c4d44" strokeWidth="1.8" /><path d="M19.4 13.5a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2v.1a2 2 0 1 1-4 0v-.1A1.7 1.7 0 0 0 6.5 19l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0-1.2-2.9H2.4a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4 6.5l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 2.9-1.2V2.4a2 2 0 1 1 4 0v.1A1.7 1.7 0 0 0 17.5 4l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0 1.2 1.8Z" stroke="#3c4d44" strokeWidth="1.6" strokeLinejoin="round" /></Ic>);

  return (
    <React.Fragment>
      <nav className={"navbar navbar-expand-lg fixed-top sticky p-0 jsa-navbar " + navClass} id="navigation">
        <Container fluid className="custom-container" style={{ height: 68, display: "flex", alignItems: "center", gap: 22 }}>
          <Link to="/" className="navbar-brand" style={{ color: "#16271f", margin: 0 }}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 9 }}>
              <span style={{ width: 30, height: 30, borderRadius: 9, background: "linear-gradient(145deg,#00b368,#008a4d)", display: "inline-flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 12px rgba(0,154,87,.32)" }}><Briefcase /></span>
              <span style={{ fontWeight: 800, fontSize: 20, letterSpacing: "-.02em", color: "#16271f" }}>job<span style={{ color: "#009b57" }}>space</span></span>
            </span>
          </Link>
          <span className="powered-noser" style={{ fontSize: 11, color: "#9aa8a0", alignSelf: "flex-end", marginBottom: 16, marginLeft: -12 }}>powered by Noser</span>

          <nav className="jsa-nav-links" style={{ display: "flex", alignItems: "center", gap: 2, marginLeft: 10 }}>
            {navLink("Find Jobs", "/?view=jobs")}
            {navLink("Companies", "/?view=companies")}
            {loggedIn && !isEmployer && navLink("My Applications", "/MyApplications")}
            <span style={{ padding: "8px 13px", fontSize: 14.5, fontWeight: 500, color: "#5f7068", cursor: "pointer" }}>Career Advice</span>
          </nav>

          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
            {loggedIn ? (
              <>
                <Link to="/?view=notifications" className="jsa-iconbtn" style={{ width: 42, height: 42, borderRadius: 12, border: "1.5px solid #e6ece7", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}><Bell /></Link>
                <div style={{ position: "relative" }} ref={ref}>
                  <button onClick={() => setMenuOpen((v) => !v)} className="jsa-menubtn" style={{ display: "flex", alignItems: "center", gap: 9, padding: "5px 9px 5px 5px", borderRadius: 100, border: "1.5px solid " + (menuOpen ? "#bfe4d0" : "#e6ece7"), background: "#fff", cursor: "pointer" }}>
                    <span style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(145deg,#16b36a,#067a44)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 13 }}>{initials}</span>
                    <span className="jsa-username" style={{ fontSize: 14, fontWeight: 700, color: "#16271f" }}>{displayName || "Account"}</span>
                    <Chevron />
                  </button>

                  {menuOpen && (
                    <div style={{ position: "absolute", top: "calc(100% + 10px)", right: 0, zIndex: 45, width: 250, background: "#fff", border: "1px solid #e6ece7", borderRadius: 16, boxShadow: "0 16px 44px rgba(20,50,38,.18)", padding: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 11, padding: "10px 11px 12px" }}>
                        <span style={{ width: 42, height: 42, borderRadius: "50%", background: "linear-gradient(145deg,#16b36a,#067a44)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 16 }}>{initials}</span>
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontSize: 14.5, fontWeight: 800, lineHeight: 1.2 }}>{displayName || "Your account"}</div>
                          <div style={{ fontSize: 12.5, color: "#7c8b82", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{displayEmail}</div>
                        </div>
                      </div>
                      <div style={{ height: 1, background: "#eef2ee", margin: "2px 4px 6px" }} />

                      {isEmployer ? (
                        <>
                          {employerItems.map((m) => (
                            <button key={m.label} onClick={() => { navigate(m.to); setMenuOpen(false); }} className="jsa-menuitem" style={menuItemStyle}>
                              {tableIcon}{m.label}
                            </button>
                          ))}
                          <button onClick={checklistCompany} className="jsa-menuitem" style={menuItemStyle}>
                            {userIcon}My Profile
                          </button>
                        </>
                      ) : (
                        <>
                          <button onClick={onclickCandidate} className="jsa-menuitem" style={menuItemStyle}>
                            {userIcon}Profile
                          </button>
                          <button onClick={() => { navigate("/MyApplications"); setMenuOpen(false); }} className="jsa-menuitem" style={menuItemStyle}>
                            {fileIcon}My Applications
                          </button>
                          <button onClick={() => { navigate("/?view=notifications"); setMenuOpen(false); }} className="jsa-menuitem" style={menuItemStyle}>
                            <Bell />Notifications
                          </button>
                          <button onClick={() => { navigate("/?view=settings"); setMenuOpen(false); }} className="jsa-menuitem" style={menuItemStyle}>
                            {gearIcon}Settings
                          </button>
                        </>
                      )}

                      <div style={{ height: 1, background: "#eef2ee", margin: "6px 4px" }} />
                      <button onClick={logout} className="jsa-logout" style={{ ...menuItemStyle, color: "#d23b30" }}>
                        <Ic><path d="M15 17v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1" stroke="#d23b30" strokeWidth="1.8" strokeLinecap="round" /><path d="M9 12h11m0 0-3-3m3 3-3 3" stroke="#d23b30" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></Ic>
                        Log out
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <Link to="/signin" style={{ padding: "9px 14px", fontSize: 14.5, fontWeight: 600, color: "#16271f", textDecoration: "none" }}>Sign In</Link>
                <Link to="/signup" className="jsa-primary" style={{ padding: "9px 17px", borderRadius: 10, fontSize: 14.5, fontWeight: 700, color: "#fff", background: "#009b57", textDecoration: "none", boxShadow: "0 4px 12px rgba(0,154,87,.28)" }}>Register</Link>
              </>
            )}
          </div>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default NavBar;
